import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class KeyboardNavigationService {
  private renderer: Renderer2;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  init() {
    this.renderer.listen('document', 'keydown', (e: KeyboardEvent) => {
      if (e.key === 'Tab' || e.key === 'ArrowUp' || e.key === 'ArrowDown' ||
        e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        this.renderer.addClass(document.body, 'using-keyboard');
      }
    });

    this.renderer.listen('document', 'mousedown', () => {
      this.renderer.removeClass(document.body, 'using-keyboard');
    });
  }
}
